var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [
        "mr10 mb5 bg-cl-transparent relative flex pointer color",
        _vm.isActive ? "active" : ""
      ],
      attrs: { "aria-label": _vm.$t("Select color ") + _vm.variant.label },
      on: {
        click: function($event) {
          return _vm.$emit("change", _vm.variant)
        }
      }
    },
    [
      _c("span", {
        staticClass: "block color-inside",
        class: [
          {
            active:
              _vm.isActive &&
              _vm.$route.meta.category === _vm.config.rootcategories.drukowanie
          },
          {
            active_office:
              _vm.isActive &&
              _vm.$route.meta.category === _vm.config.rootcategories.biuro
          }
        ]
      }),
      _vm._v(" "),
      _c("span", { staticClass: "ml20 cl-black h5 uppercase color-label" }, [
        _vm._v("\n    " + _vm._s(_vm.variant.label) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }